import {
  SET_NOTIFICATIONS_SETTINGS
} from '@/store/mutationTypes.js'
import env from '@/env.js'
import notificationsMS from '@/services/notificationsMS'
import chatOrchestratorMS from '@/services/chatOrchestratorMS'
import getDataToUpdateChatbotMessage from '@/helpers/getDataToUpdateChatbotMessage'

const CHAT_ORCHESTRATOR_PATH = env('CHAT_ORCHESTRATOR_PATH')

const state = () => ({
  notificationsSettings: null
})

const getters = {
  notificationsSettingsChatbotMessage: (state) => {
    if (!state.notificationsSettings) return null
    return state.notificationsSettings?.chatbot_settings?.messages || null
  }
}

const actions = {
  async getNotificationsSettings ({ commit }) {
    try {
      let notificationsSettings

      if (CHAT_ORCHESTRATOR_PATH) {
        const [notifResponse, chatOrchestratorResponse] = await Promise.allSettled([
          notificationsMS.getSettings(),
          chatOrchestratorMS.getSettings()
        ])

        if (notifResponse.status === 'rejected') {
          throw notifResponse.reason
        }

        notificationsSettings = notifResponse.value

        if (chatOrchestratorResponse.status === 'fulfilled') {
          notificationsSettings = {
            ...notificationsSettings,
            chatbot_settings: chatOrchestratorResponse.value.chatbot_settings
          }
        } else {
          console.error(chatOrchestratorResponse.reason)
        }
      } else {
        notificationsSettings = await notificationsMS.getSettings()
      }

      commit(SET_NOTIFICATIONS_SETTINGS, notificationsSettings)
    } catch (error) {
      console.error(error)
    }
  }
}

const mutations = {
  [SET_NOTIFICATIONS_SETTINGS] (state, settings) {
    const settingsChatbotMessage = settings.chatbot_settings?.messages || null
    settings.chatbot_settings = getDataToUpdateChatbotMessage(settingsChatbotMessage)

    state.notificationsSettings = settings
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
